import BaseModel from "./base_model";
import sync from "./invoca_sync";

class SyncableModel extends BaseModel {}
SyncableModel.prototype.sync = sync;

export default SyncableModel;
